import React from 'react';
import { useNavigate } from 'react-router-dom';

import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { ContentContainer, ButtonContainer } from './styles';

function SuccessModal({ open, setOpen }) {
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/support');
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <ContentContainer>
        <Typography variant="h3" component="h4" sx={{ mb: 2 }}>
          Mensagem enviada com sucesso!
        </Typography>
        <Typography sx={{ mb: 3 }} variant="body1" color="text.secondary">
          Sua solicitação será analisada por nossa equipe, e você receberá uma
          notificação por e-mail assim que houver uma resposta.
        </Typography>
        <ButtonContainer>
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              px: 8,
              backgroundColor: '#1976d2',
              '&:hover': {
                backgroundColor: '#1565c0',
              },
            }}
          >
            OK
          </Button>
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
}

export default SuccessModal;
